import React from "react";
import TransferItemTab from "./TransferAnalyzer-TransferItem";
import PersonelTab from "./TransferAnalyzer-TransferPersonels";
import ServiceTab from "./TransferAnalyzer-TransferServices";

export const buildTransferAnalyzerTabs = ({
  t,
  transfer,
  onClose,
  usersInTheTransfer,
  services,
  servicesOptions,
  school,
  displayName,
  transfertime,
  type,
  handlers,
}) => {
  const transferItemTab = <TransferItemTab transfer={transfer} onClose={onClose} />;

  const personelTab = (
    <PersonelTab
      users={usersInTheTransfer}
      services={services}
      servicesOptions={servicesOptions}
      school={school}
      date={transfer.transferdate}
      displayName={displayName}
      onAddPersonel={handlers.addPersonelHandler}
      onRemovePersonel={handlers.removePersonelHandler}
      onChangeUserService={handlers.changeUserServiceHandler}
      onChangeUserTransferTime={handlers.changeUserTransferTimeHandler}
      onSendSms={handlers.sendSMSHandler}
      onSendAllSms={handlers.sendAllSMSHandler}
    />
  );

  const serviceTab = (
    <ServiceTab
      school={school}
      type={type}
      users={usersInTheTransfer}
      transfertime={transfertime}
      services={services}
      date={transfer.transferdate}
      displayName={displayName}
      changeUserService={handlers.changeUserServiceHandler}
      addPersonel={handlers.addPersonelHandler}
      removePersonel={handlers.removePersonelHandler}
      addService={handlers.addServiceHandler}
      deleteService={handlers.deleteServiceHandler}
    />
  );

  return [
    { label: t("transferAnalyzer.tabs.transferInfo"), content: transferItemTab },
    { label: t("transferAnalyzer.tabs.transferPersonnel"), content: personelTab },
    { label: t("transferAnalyzer.tabs.transferServices"), content: serviceTab },
  ];
};
